import React from 'react'
import { Switch } from 'antd'

const SwitchInput = ({ label, checked, onChange }) => {
  return (
    <div className="flex flex-row items-center space-x-2">
      <Switch checked={checked} onChange={onChange} />
      {label ? <span>{label}</span> : ''}
    </div>
  )
}

export default SwitchInput
